<div>
  <div class="row">
    <div class="row col-lg-12 pb-1" style="justify-content: space-between">
      <div class="row col-lg-10 pl-4">
        <h1>Inspections Search</h1>
        <div class="mt-1 pl-3">
          <button type="button" class="btn btn-danger" *ngIf="hasFilters()" (click)="resetAll()">Reset All</button>
        </div>
      </div>
      <div class="row col-lg-2" style="justify-content: right">
        <button
          class="btn aru btn-sm btn-primary"
          [disabled]="!hasFilters() || inspections?.length === 0"
          (click)="downloadCsv()">
          Download as CSV
        </button>
      </div>
    </div>
    <div class="col-md-12">
      <app-search-filter
        [filters]="definedFilters"
        [params]="params"
        (filtersUpdated)="filtersUpdated($event)"></app-search-filter>
    </div>
  </div>
  <br />
  <ngx-loading [show]="loading"></ngx-loading>
  <div class="table-wrapper" *ngIf="inspections?.length">
    <table class="table aru pointer">
      <thead>
        <tr>
          <th *ngFor="let field of defaultFields" (click)="setOrder(field.sort)">
            {{ field.label | titlecase }}
            <i class="fa" [ngClass]="getOrderIcon(field.sort)"></i>
          </th>
          <th *ngFor="let field of otherFields" (click)="setOrder(field.sort)">
            {{ field.label | titlecase }}
            <i class="fa" [ngClass]="getOrderIcon(field.sort)"></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of inspections" (click)="open($event, row.id)">
          <td *ngFor="let field of defaultFields">
            {{ getDisplayValue(row, field) }}
          </td>
          <td *ngFor="let field of otherFields">
            {{ getValueFromPath(row, field.name, field.path) }}
          </td>
          <td>
            <div class="dropdown" dropdown>
              <button type="button" class="btn" dropdownToggle>
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div class="dropdown-menu right" *dropdownMenu>
                <a *ngIf="canReview" class="dropdown-item" (click)="redirectReview(row)">Review</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="inspections?.length === 0 && !loading" id="search-wrapper">
    <div class="no-result">
      <h2>No search results.</h2>
      <button class="btn btn-danger" (click)="resetAll()">Reset All</button>
    </div>
  </div>

  <pagination
    class="pagination"
    [(ngModel)]="page"
    [totalItems]="count"
    [itemsPerPage]="pageSize"
    [maxSize]="5"
    [boundaryLinks]="true"
    [rotate]="false"
    (pageChanged)="onPageChanged($event.page)"
    *ngIf="inspections?.length && count">
  </pagination>
</div>
